/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const vehicleMakes = [
  { label: "A.D. TRAMONTANA" },
  { label: "A.T.U" },
  { label: "AC" },
  { label: "AC PROPULSION" },
  { label: "Access" },
  { label: "ACURA" },
  { label: "Adiva" },
  { label: "Adler" },
  { label: "Adly" },
  { label: "Adria" },
  { label: "Aeon" },
  { label: "Aermacchi" },
  { label: "AGM" },
  { label: "Ahorn" },
  { label: "Aiyumo" },
  { label: "AJP" },
  { label: "AJS" },
  { label: "ALFA ROMEO" },
  { label: "Alfa Scooters" },
  { label: "Alisze" },
  { label: "ALMAC" },
  { label: "Alpha" },
  { label: "Alpha Motors" },
  { label: "ALTERNATIVE CARS" },
  { label: "AMC Est 1902" },
  { label: "AMUZA" },
  { label: "ANTEROS" },
  { label: "APEX" },
  { label: "APG Moto" },
  { label: "Aprilia" },
  { label: "ARASH" },
  { label: "Arc" },
  { label: "Arctic Cat" },
  { label: "Ardie" },
  { label: "ARIEL" },
  { label: "Ariel Motor" },
  { label: "Ariel Motorcycles" },
  { label: "ARRINERA" },
  { label: "Asiawing" },
  { label: "Askoll" },
  { label: "ASL" },
  { label: "ASTERIO" },
  { label: "ASTON MARTIN" },
  { label: "Atala" },
  { label: "ATK" },
  { label: "AUDI" },
  { label: "AWO" },
  { label: "BAC" },
  { label: "BAJAJ" },
  { label: "Bajaj" },
  { label: "Baotian" },
  { label: "Barossa" },
  { label: "Bashan" },
  { label: "Beeline" },
  { label: "BEIJING AUTOMOBILE WORKS" },
  { label: "Benda" },
  { label: "Benelli" },
  { label: "BENTLEY" },
  { label: "Benzhou" },
  { label: "Beta" },
  { label: "BFG" },
  { label: "Big Dog" },
  { label: "bimobil" },
  { label: "Bimota" },
  { label: "Blata" },
  { label: "BMW" },
  { label: "BOLLORÉ" },
  { label: "BOLWELL" },
  { label: "Bombardier" },
  { label: "Boom Trike" },
  { label: "Borile" },
  { label: "Borossi" },
  { label: "Boss Hoss" },
  { label: "Brammo" },
  { label: "BRILLIANCE / HUACHEN" },
  { label: "BRISTOL" },
  { label: "BRITISH LEYLAND" },
  { label: "Britten" },
  { label: "Brixton" },
  { label: "BRM BUGGY" },
  { label: "BROOKE" },
  { label: "Brough Superior" },
  { label: "BSA" },
  { label: "BUDDY" },
  { label: "Buell" },
  { label: "BUFORI" },
  { label: "BUGATTI" },
  { label: "BUICK" },
  { label: "Bull" },
  { label: "Bullit" },
  { label: "Bultaco" },
  { label: "Burelli" },
  { label: "Buyang" },
  { label: "BYD" },
  { label: "Bücker" },
  { label: "Bürstner" },
  { label: "CADILLAC" },
  { label: "Cagiva" },
  { label: "Calthorpe" },
  { label: "Can Am" },
  { label: "Cannondale" },
  { label: "CAPARO" },
  { label: "Carado" },
  { label: "CARBONTECH" },
  { label: "CARICE" },
  { label: "Carthago" },
  { label: "CCM" },
  { label: "CCS" },
  { label: "Cectek" },
  { label: "CF Moto" },
  { label: "Challenger" },
  { label: "Chang - Jiang" },
  { label: "CHANG'AN" },
  { label: "CHANGHE" },
  { label: "Chausson" },
  { label: "CHERY" },
  { label: "CHEVROLET" },
  { label: "CHEVRON" },
  { label: "Chinabike" },
  { label: "Christini" },
  { label: "CHRYSLER" },
  { label: "CI International Riviera" },
  { label: "CITROËN" },
  { label: "Cleveland" },
  { label: "Cobra" },
  { label: "COMMUTER CARS" },
  { label: "Concorde" },
  { label: "Condor" },
  { label: "Confederate" },
  { label: "CONNAUGHT" },
  { label: "Cotton" },
  { label: "COVINI" },
  { label: "CPI" },
  { label: "CR&amp;S" },
  { label: "Csepel" },
  { label: "CSR" },
  { label: "CZ" },
  { label: "D-RAD" },
  { label: "DACIA" },
  { label: "Daelim" },
  { label: "DAIHATSU" },
  { label: "DATSUN" },
  { label: "DE LA CHAPELLE" },
  { label: "Derbi" },
  { label: "Dethleffs" },
  { label: "Di Blasi" },
  { label: "DIARDI" },
  { label: "Dinli" },
  { label: "DKW" },
  { label: "DMC" },
  { label: "Dnepr" },
  { label: "DODGE" },
  { label: "DONGFENG" },
  { label: "Donghai" },
  { label: "DONKERVOORT" },
  { label: "DONTO" },
  { label: "Doohan" },
  { label: "Dorton" },
  { label: "Douglas" },
  { label: "DS AUTOMOBILES" },
  { label: "Ducati" },
  { label: "DYNASTI ELECTRIC CAR CORP." },
  { label: "Dürkopp" },
  { label: "E-Max" },
  { label: "E-Rider" },
  { label: "E-Sprit" },
  { label: "E-Ton" },
  { label: "E-VADE" },
  { label: "E.-ATV" },
  { label: "EBR" },
  { label: "Ecomobile" },
  { label: "Econelo" },
  { label: "Edrive" },
  { label: "EFFEDI" },
  { label: "Efun" },
  { label: "Egli" },
  { label: "EGY-TECH ENGINEERING" },
  { label: "EH Line" },
  { label: "Electrack" },
  { label: "Electric Motion" },
  { label: "ELECTRIC RACEABOUT" },
  { label: "Elektra" },
  { label: "ELFIN" },
  { label: "Elmoto" },
  { label: "Elnagh" },
  { label: "Emco" },
  { label: "EMGRAND" },
  { label: "EMW" },
  { label: "Energica" },
  { label: "ENGLON" },
  { label: "Epella" },
  { label: "EQUUS" },
  { label: "Erider" },
  { label: "Ering" },
  { label: "ETERNITI" },
  { label: "ETOX" },
  { label: "Eura" },
  { label: "EXAGON" },
  { label: "Excalibur" },
  { label: "Explorer" },
  { label: "Express" },
  { label: "Fantic" },
  { label: "FARALLI & MAZZANTI" },
  { label: "FAW" },
  { label: "Fecht Trike" },
  { label: "Fendt" },
  { label: "FERRARI" },
  { label: "FIAT" },
  { label: "FISKER" },
  { label: "FK Motors" },
  { label: "FN" },
  { label: "FODAY" },
  { label: "FORCE" },
  { label: "FORD" },
  { label: "FORD AUSTRALIA" },
  { label: "FORD GERMANY" },
  { label: "FORNASARI" },
  { label: "Forster" },
  { label: "Frankia" },
  { label: "FRASER" },
  { label: "Frischauf" },
  { label: "Futura" },
  { label: "GAC GROUP" },
  { label: "GALPIN" },
  { label: "Garelli" },
  { label: "Gas Gas" },
  { label: "GEELY" },
  { label: "Genata" },
  { label: "Generic" },
  { label: "GENESIS" },
  { label: "GG" },
  { label: "Ghezzi-Brian" },
  { label: "Giantco" },
  { label: "GIBBS" },
  { label: "Gilera" },
  { label: "GILLET" },
  { label: "Gillet Herstal" },
  { label: "GINETTA" },
  { label: "Giottiline PLA" },
  { label: "Glücksmobil" },
  { label: "GMC" },
  { label: "Gnome et Rhône" },
  { label: "Goes" },
  { label: "Goggo" },
  { label: "GONOW" },
  { label: "Govecs" },
  { label: "Grace" },
  { label: "GREAT WALL / CHANGCHENG" },
  { label: "GREENTECH AUTOMOTIVE" },
  { label: "GRINNALL" },
  { label: "Gritzner-Kayser" },
  { label: "GT Union" },
  { label: "GTA MOTOR" },
  { label: "GUF" },
  { label: "GUMPERT" },
  { label: "GURGEL" },
  { label: "Hanway" },
  { label: "Harley-Davidson" },
  { label: "Headbanger" },
  { label: "Hecker" },
  { label: "Heinkel" },
  { label: "Heku" },
  { label: "Henderson" },
  { label: "HENNESSEY" },
  { label: "Hercules" },
  { label: "Herk" },
  { label: "Herkules" },
  { label: "Highland" },
  { label: "HINDUSTAN" },
  { label: "Hisun" },
  { label: "HM" },
  { label: "HMW" },
  { label: "Hobby" },
  { label: "Hoffmann" },
  { label: "HOLDEN" },
  { label: "HONDA" },
  { label: "Honda" },
  { label: "HONGQI" },
  { label: "Horex" },
  { label: "Horwin" },
  { label: "HRADYESH" },
  { label: "HRD" },
  { label: "HTT TECHNOLOGIES" },
  { label: "HULME" },
  { label: "Hummel" },
  { label: "Huoniao" },
  { label: "Husaberg" },
  { label: "Husqvarna" },
  { label: "Hymer" },
  { label: "Hyosung" },
  { label: "HYUNDAI" },
  { label: "ICML" },
  { label: "IFA" },
  { label: "IFR" },
  { label: "IKCO" },
  { label: "IMG" },
  { label: "Imme" },
  { label: "IMPERIA" },
  { label: "Imperia" },
  { label: "Indian" },
  { label: "INFINITI" },
  { label: "Innoscooter" },
  { label: "INVICTA" },
  { label: "IO" },
  { label: "IRAN KHODRO" },
  { label: "ISDERA" },
  { label: "ISUZU" },
  { label: "Italjet" },
  { label: "IVM" },
  { label: "IWL" },
  { label: "JAC" },
  { label: "Jack Fox" },
  { label: "JAGUAR" },
  { label: "Jawa" },
  { label: "JEEP" },
  { label: "JENSEN MOTORS" },
  { label: "JETCAR" },
  { label: "Jianshe" },
  { label: "Jincheng" },
  { label: "Jinling" },
  { label: "Jinlun" },
  { label: "Jmstar" },
  { label: "Joint" },
  { label: "JONWAY" },
  { label: "Jonway" },
  { label: "JOSS" },
  { label: "Jotagas" },
  { label: "Junak" },
  { label: "Kabe" },
  { label: "KAIPAN" },
  { label: "KANTANKA" },
  { label: "KARMA" },
  { label: "Karmann Mobil" },
  { label: "Kawasaki" },
  { label: "Keeway" },
  { label: "KIA" },
  { label: "KIAT" },
  { label: "Kinroad" },
  { label: "KISH KHODRO" },
  { label: "Knaus" },
  { label: "KOENIGSEGG" },
  { label: "KORRES" },
  { label: "Kreidler" },
  { label: "KSR Moto" },
  { label: "KTM" },
  { label: "Kumpan Electric" },
  { label: "KVN" },
  { label: "Kwang Yang" },
  { label: "Kymco" },
  { label: "la strada" },
  { label: "LADA" },
  { label: "Laika" },
  { label: "LAMBORGHINI" },
  { label: "Lambretta" },
  { label: "LANCIA" },
  { label: "LAND ROVER" },
  { label: "LANDWIND" },
  { label: "LARAKI" },
  { label: "Lauge Jensen" },
  { label: "Laverda" },
  { label: "LEBLANC" },
  { label: "Leike" },
  { label: "LEITCH" },
  { label: "LEM" },
  { label: "Leonart" },
  { label: "LEOPARD" },
  { label: "LEXUS" },
  { label: "LI-ION" },
  { label: "LIFAN" },
  { label: "Lifan" },
  { label: "LIGHTNING" },
  { label: "Lightning" },
  { label: "LINCOLN" },
  { label: "Lingben" },
  { label: "Linhai" },
  { label: "LISTER" },
  { label: "LMC" },
  { label: "LML" },
  { label: "LOBINI" },
  { label: "LOCAL MOTORS" },
  { label: "Lohner" },
  { label: "Loncin" },
  { label: "Longjia" },
  { label: "LOTEC" },
  { label: "LOTUS CARS" },
  { label: "LUCRA CARS" },
  { label: "LUXGEN" },
  { label: "Luxxon" },
  { label: "Mabeco" },
  { label: "Magni" },
  { label: "MAHINDRA" },
  { label: "Maico" },
  { label: "Malaguti" },
  { label: "Malibu" },
  { label: "Mars" },
  { label: "MARUSSIA" },
  { label: "MARUTI SUZUKI" },
  { label: "Masai" },
  { label: "MASERATI" },
  { label: "Mash" },
  { label: "Masini" },
  { label: "MASTRETTA" },
  { label: "Matchless" },
  { label: "MAZDA" },
  { label: "MBK" },
  { label: "Mc Motors" },
  { label: "MCLAREN" },
  { label: "McLoius" },
  { label: "Megelli" },
  { label: "MERCEDES-BENZ" },
  { label: "MG" },
  { label: "MICRO" },
  { label: "Miele" },
  { label: "Miller" },
  { label: "MINI" },
  { label: "Minimoto" },
  { label: "MITSUBISHI" },
  { label: "MITSUOKA" },
  { label: "Mobilvetta" },
  { label: "Mondial" },
  { label: "Montesa" },
  { label: "Morelo" },
  { label: "MORGAN" },
  { label: "Moto Guzzi" },
  { label: "Moto Morini" },
  { label: "Moto Parilla" },
  { label: "Motobecane" },
  { label: "Motobi" },
  { label: "Motom" },
  { label: "Motorhispania" },
  { label: "Motosacoche" },
  { label: "Motowell" },
  { label: "MTR" },
  { label: "MULLEN" },
  { label: "MV Agusta" },
  { label: "MYCAR" },
  { label: "MYVI-PERODUA" },
  { label: "MZ" },
  { label: "Münch" },
  { label: "NCR" },
  { label: "New Hudson" },
  { label: "New Imperial" },
  { label: "Niesmann + Bischoff" },
  { label: "Nimbus" },
  { label: "Ninebot" },
  { label: "NISSAN" },
  { label: "Nitro Motors" },
  { label: "Niu" },
  { label: "nobelart" },
  { label: "NOBLE" },
  { label: "Norton" },
  { label: "NOTA" },
  { label: "Nova Motors" },
  { label: "NSU" },
  { label: "OLDSMOBILE" },
  { label: "OLTCIT" },
  { label: "Online" },
  { label: "OPEL" },
  { label: "Opel" },
  { label: "OPTIMAL ENERGY" },
  { label: "Orangecamp" },
  { label: "ORCA" },
  { label: "Oset" },
  { label: "Ossa" },
  { label: "OULLIM" },
  { label: "Over Bikes" },
  { label: "P.G.O." },
  { label: "PAGANI" },
  { label: "Palmo" },
  { label: "PANHARD" },
  { label: "PANOZ" },
  { label: "Panther" },
  { label: "Pegasus" },
  { label: "PERANA" },
  { label: "Peraves" },
  { label: "PERODUA" },
  { label: "PEUGEOT" },
  { label: "Peugeot" },
  { label: "PGO" },
  { label: "Phoenix" },
  { label: "Piaggio" },
  { label: "Pilote" },
  { label: "PIT Racing" },
  { label: "PLYMOUTH" },
  { label: "Pocket Bike" },
  { label: "Polaris" },
  { label: "POLARSUN" },
  { label: "Polini" },
  { label: "PORSCHE" },
  { label: "PROTO" },
  { label: "PROTON" },
  { label: "Puch" },
  { label: "PURITALIA" },
  { label: "Pössl" },
  { label: "Qingqi" },
  { label: "Qooder" },
  { label: "QOROS" },
  { label: "Quadix" },
  { label: "Quadro" },
  { label: "Quantya" },
  { label: "QVALE" },
  { label: "Rabeneick" },
  { label: "RADICAL" },
  { label: "Razory" },
  { label: "Real" },
  { label: "Rechenberg" },
  { label: "Regal-Raptor" },
  { label: "RELIANT" },
  { label: "RENAULT" },
  { label: "REVA" },
  { label: "Rewaco" },
  { label: "REX" },
  { label: "Rickman" },
  { label: "Ride" },
  { label: "Rieju" },
  { label: "RIMAC" },
  { label: "Rimor" },
  { label: "RINSPEED" },
  { label: "Rivero" },
  { label: "Rixe" },
  { label: "RMW" },
  { label: "RODING" },
  { label: "ROEWE" },
  { label: "Rolektro" },
  { label: "RollerFoxx" },
  { label: "Rollerteam Granduca" },
  { label: "ROLLS-ROYCE" },
  { label: "Romet" },
  { label: "ROSSIN-BERTIN" },
  { label: "ROSSION" },
  { label: "ROVER" },
  { label: "Royal Enfield" },
  { label: "Rudge" },
  { label: "Rumi" },
  { label: "SAAB" },
  { label: "Sachs/SFM" },
  { label: "SAIC-GM-WULING" },
  { label: "SAIPA" },
  { label: "SAKER" },
  { label: "SALEEN" },
  { label: "SAMSUNG" },
  { label: "SAN" },
  { label: "Sanglas" },
  { label: "Saroléa" },
  { label: "Saxon" },
  { label: "SBARRO" },
  { label: "Scarabeo" },
  { label: "Schüttoff" },
  { label: "SCION" },
  { label: "Scomadi" },
  { label: "Scorpa" },
  { label: "Scott" },
  { label: "SDG" },
  { label: "SEAT" },
  { label: "Seikel" },
  { label: "SEV" },
  { label: "SHANGHAI MAPLE" },
  { label: "Sherco" },
  { label: "Shineray" },
  { label: "Si.O" },
  { label: "Silence" },
  { label: "Simson" },
  { label: "SIN" },
  { label: "Skyteam" },
  { label: "SMART" },
  { label: "SMC" },
  { label: "Solo" },
  { label: "Somoto" },
  { label: "SPADA VETTURE SPORT" },
  { label: "SPYKER" },
  { label: "SSANGYONG" },
  { label: "SSC NORTH AMERICA" },
  { label: "Standard" },
  { label: "Steereon" },
  { label: "Stels" },
  { label: "Stock" },
  { label: "STREET & RACING TECHNOLOGY" },
  { label: "SUBARU" },
  { label: "Sumco" },
  { label: "Sun Living" },
  { label: "Sunbeam" },
  { label: "Sunlight" },
  { label: "Super Soco" },
  { label: "SUZUKI" },
  { label: "Suzuki" },
  { label: "SWM" },
  { label: "SXT" },
  { label: "SYM" },
  { label: "T.E.C" },
  { label: "Tacita" },
  { label: "TANOM" },
  { label: "Tante Paula" },
  { label: "TATA" },
  { label: "Tauris" },
  { label: "TAURO" },
  { label: "TAWON CAR" },
  { label: "TD CARS" },
  { label: "Terrot" },
  { label: "TESLA" },
  { label: "TGB" },
  { label: "THA" },
  { label: "THAI RUNG" },
  { label: "Thumpstar" },
  { label: "TM" },
  { label: "Tomaszo" },
  { label: "Tomos" },
  { label: "Tornax" },
  { label: "Torrot" },
  { label: "Toth-Twa" },
  { label: "Touratech" },
  { label: "TOYOTA" },
  { label: "TREKKA" },
  { label: "TRIDENT" },
  { label: "Trike" },
  { label: "Trinity" },
  { label: "Triton" },
  { label: "TRIUMPH" },
  { label: "Triumph" },
  { label: "TROLLER" },
  { label: "TRUMPCHI" },
  { label: "Turbho" },
  { label: "TUSHEK" },
  { label: "TVR" },
  { label: "TVS" },
  { label: "UAZ" },
  { label: "UEV" },
  { label: "ULTIMA" },
  { label: "Ultra Motor" },
  { label: "UMM" },
  { label: "Unu Motors" },
  { label: "Ural" },
  { label: "URI" },
  { label: "UT" },
  { label: "Vahrenkamp" },
  { label: "VAUXHALL MOTORS" },
  { label: "VECTOR" },
  { label: "Vectrix" },
  { label: "Velocette" },
  { label: "Velosolex" },
  { label: "VENCER" },
  { label: "VENIRAUTO" },
  { label: "VENTURI" },
  { label: "Venturino" },
  { label: "VEPR" },
  { label: "Vertemati" },
  { label: "Verve Moto" },
  { label: "Vespa" },
  { label: "Vespino" },
  { label: "Victoria" },
  { label: "Victory" },
  { label: "Villa" },
  { label: "Vincent" },
  { label: "VINFAST" },
  { label: "Voge" },
  { label: "VOLKSWAGEN" },
  { label: "Volta" },
  { label: "VOLVO" },
  { label: "VOR Vertemati" },
  { label: "Voxan" },
  { label: "VR" },
  { label: "Völkner" },
  { label: "W MOTORS" },
  { label: "W-Tec" },
  { label: "Wakan" },
  { label: "WALLYSCAR" },
  { label: "Wanderer" },
  { label: "Wanjin" },
  { label: "Watsonian/Squire" },
  { label: "Weinsberg" },
  { label: "Wellbrock" },
  { label: "Westfalia" },
  { label: "WESTFIELD" },
  { label: "WHEEGO" },
  { label: "WIESMANN" },
  { label: "Wild Eagle" },
  { label: "WMI" },
  { label: "Wochner" },
  { label: "WRM" },
  { label: "Wüdo" },
  { label: "X-Spin" },
  { label: "XENIA" },
  { label: "XGO" },
  { label: "Xingfu" },
  { label: "Xingyue" },
  { label: "Xispa" },
  { label: "XPA" },
  { label: "Yamaha" },
  { label: "YCF" },
  { label: "YES!" },
  { label: "Yiben" },
  { label: "YOUABIAN PUMA" },
  { label: "Yukon-Atv" },
  { label: "ZASTAVA AUTOMOBILES" },
  { label: "ZENDER CARS" },
  { label: "ZENOS CARS" },
  { label: "ZENVO" },
  { label: "Zero" },
  { label: "Zhejiang" },
  { label: "Zhongneng" },
  { label: "Zhongshan" },
  { label: "Zhongyu" },
  { label: "ZIL" },
  { label: "Zing" },
  { label: "Zipp" },
  { label: "Znen" },
  { label: "Zongshen" },
  { label: "Zontes" },
  { label: "ZTR" },
  { label: "Zweirad Union" },
  { label: "ZX AUTO" },
  { label: "Zündapp" },
  { label: "ŠKODA" },
];

export default vehicleMakes;
